import { Injectable, inject } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse
} from '@angular/common/http';
import { Observable, from, of } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { Capacitor } from '@capacitor/core';
import { Http } from '@capacitor-community/http';
import {environment} from "../../environments/environment";

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const auth = inject(AuthenticationService);
    const baseUrl = environment.apiUrl;
    const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;



    const isAsset = req.url.startsWith('assets/') || req.url.startsWith('/assets/');
    if (isAsset) {
      return next.handle(req);
    }

    if (req.headers.has('Skip-Interceptor') || req.url.includes('blob.core.windows.net')) {

      return next.handle(req.clone({ headers: req.headers.delete('Skip-Interceptor') }));
    }


    const isAbsolute = /^https?:\/\//i.test(req.url);
    const alreadyPrefixed =
      req.url === normalizedBaseUrl ||
      req.url.startsWith(`${normalizedBaseUrl}/`) ||
      req.url.startsWith('/api/');
    const url = (isAbsolute || alreadyPrefixed)
      ? req.url
      : `${normalizedBaseUrl}${req.url.startsWith('/') ? '' : '/'}${req.url}`;

    const token = auth.getAccessToken();

    if (Capacitor.isNativePlatform()) {
      const isFormData = req.body instanceof FormData;
      const headers: Record<string, string> = {};

      // Only set Content-Type manually if not FormData
      if (!isFormData) headers['Content-Type'] = 'application/json';
      if (token) headers.Authorization = `Bearer ${token}`;

      const requestConfig: any = {
        method: req.method,
        url,
        headers,
      };

      // Only include body for methods that support it
      if (req.method !== 'GET' && req.method !== 'HEAD' && req.body) {
        requestConfig.data = isFormData ? req.body : req.body;
      }

      console.log('[Native HTTP Request]', requestConfig);

      return from(Http.request(requestConfig)).pipe(
        mergeMap(res => {
          console.log('[Native HTTP Response]', res);
          return of(new HttpResponse({ body: res.data, status: res.status, url }));
        }),
        catchError(err => {
          console.error('[Native HTTP Error]', err);
          throw err;
        })
      );
    }


    return next.handle(req.clone({
      url,
      setHeaders: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      }
    }));
  }
}
